export default __webpack_public_path__ + "static/media/lhcf_logo.23ea6d16.jpeg";